import React from "react";
import { Typography, IconButton, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

//css
import ModalHeaderCss from "./ModalHeader-Css";
const useStyles = ModalHeaderCss();

export default (props) => {
    const classes = useStyles();
    const openConfirmHandler = () => {
        props.modelRef.current.handleOpen(props.props.params.id, "/grupoOpcoesRecebimento", true);
    };
    return (
        <div className={classes.header}>
            <Typography variant="h5" component="h3" className={classes.title}>
                {props.state.tipo} {props.props.route.title}
            </Typography>

            <div className={classes.iconButton}>
                {props.state.tipo === "Editar" && props.state.flagDelete === true && (
                    <Tooltip title={"Remover Grupo"}>
                        <IconButton className={classes.iconButton} onClick={openConfirmHandler}>
                            <DeleteIcon className={classes.icon} />
                        </IconButton>
                    </Tooltip>
                )}
            </div>
        </div>
    );
};
